import { connect } from "react-redux";
import { Monitor, Box, Truck, List, LogOut } from "react-feather";
import { CssBaseline, Grid, makeStyles, Typography } from "@material-ui/core";
import { formatarNome, formatarUrlComSessionId } from "../utils/Formatacao";
import { useContadorSessaoExpirada } from "./customHooks/useContadorSessaoExpirada";
import { atualizarDadosAcesso } from "../../features/login/LoginManager";
import Breadcrumb from "./breadcrumb/Breadcrumb"
import Cabecalho from "./Cabecalho"
import Notificacoes from "../../features/notificacoes";
import Modal from "../../shared/components/Modal";
import Conteudo from "./Conteudo";
import Logo from "./logo/Logo";
import MenuLateral from "./MenuLateral";
import SessaoExpira from "./SessaoExpira";
import UserInfo from "./UserInfo";
import Store from "../../store";
import React, { useRef } from 'react';
import { configureEnvironment } from '../../config/env';
import ChatWidget from "./ChatWidget";

const urlRastreioAmostra = configureEnvironment().REACT_APP_URL_RASTREIO_AMOSTRA;

const Layout = (props) => {
	const ConstScoreUnique = "UNIQUE";
	const classes = useStyles()

	const {
		dataExpiracao,
		estaAutenticado,
		usuarioLogado,
		laboratorio,
		tempoRenovarSessao,
		sessaoExpirada
	} = props
	const nomeUsuario = formatarNome(usuarioLogado && usuarioLogado.nome)
	const razaoSocial = formatarNome(laboratorio && laboratorio.razaoSocial)
	const codigoLaboratorio = laboratorio && laboratorio.codigo

	const scoreCliente = (laboratorio && laboratorio.scoreCliente) ?? "";
	const exibirVideoChamada = scoreCliente.includes(ConstScoreUnique);
	const existeScore = scoreCliente !== "" && scoreCliente !== undefined;
	const referenciaAncora = useRef(null);

	const mostradorTempoSessao = (tempo) => {
		return (
			<React.Fragment>
				<Typography variant="h4" className={"bold"}>
					{tempo}
				</Typography>
				<Typography>segundos restantes</Typography>
			</React.Fragment>
		)
	}

	const dadosModalSessaoExpirar = useContadorSessaoExpirada(
		tempoRenovarSessao,
		sessaoExpirada,
		atualizarDadosAcesso,
		mostradorTempoSessao,
		Store.dispatch
	)

	const cardDireito = () => (
		<Grid item xs={12} md={5} lg={5}>
			<Grid container direction="row" spacing={2} >
				<Grid item xs={4} className={classes.containerCabecalho}>
					{dataExpiracao && <SessaoExpira dataExpiracao={dataExpiracao} />}
				</Grid>
				<Grid item xs={2} className={classes.containerCabecalho}>
					<Notificacoes />
				</Grid>
				<Grid item xs={5} className={classes.containerCabecalho} style={{ paddingLeft: '0px' }} ref={referenciaAncora}>
					<UserInfo
						nome={nomeUsuario}
						usuario={usuarioLogado}
						nomeLaboratorio={razaoSocial}
						codigoLaboratorio={codigoLaboratorio}
						referenciaAncora={referenciaAncora}
					/>
				</Grid>
				<Grid item xs={1} className={classes.containerCabecalho} style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}}>
					<LogOut color="#61688B" className={classes.botaoSair} size={20} onClick={() => atualizarDadosAcesso(null)(Store.dispatch)} />
				</Grid>

			</Grid>
		</Grid >
	)

	let itensMenu = (
		[
			{
				nome: "Cadastro e gerenciamento de lotes",
				rota: "/lotes",
				icone: <Box color={"#FFFFFF"} size={24} />,
				linkInterno: true,
			},
			{
				nome: "Listagem de amostras",
				rota: "/amostras",
				icone: <List color={"#FFFFFF"} size={24} />,
				linkInterno: true,
			},
			{
				nome: "Cadastro de amostras",
				rota: "/cadastro-amostras",
				icone: <Monitor color={"#FFFFFF"} size={24} />,
				linkInterno: true,
			},
			{
				nome: "Rastreio de amostras",
				rota: formatarUrlComSessionId(urlRastreioAmostra),
				icone: <Truck color="#FFFFFF" size={24} />,
				linkInterno: false,
			},
		]
	)

	let pagina = (
		<>
			<Cabecalho left={<Breadcrumb />} right={cardDireito()} />
			<MenuLateral logo={<Logo id="logo" />} itens={itensMenu} />
			<Modal id="modalSessaoExpirar" {...dadosModalSessaoExpirar} />
			<Conteudo temMenuLateral temToolbar conteudo={props.children} />
			<ChatWidget existeScore={existeScore} exibirVideoChamada={exibirVideoChamada} />
		</>
	)

	if (!estaAutenticado) {
		pagina = (
			<>
				<CssBaseline />
				<Conteudo temMenuLateral={false} temToolbar={false} conteudo={props.children} />
			</>
		)
	}

	return pagina
}

const mapStateToProps = (state) => {
	return {
		laboratorio: state.login.laboratorio,
		usuarioLogado: state.login.usuario,
		sessaoExpirada: state.login.sessaoExpirada,
		tempoRenovarSessao: state.login.tempoRenovarSessao,
		validacaoLaboratorio: state.login.validacaoLaboratorio,
		dataExpiracao: state.login.dataExpiracao,
		estaAutenticado: state.login.usuario != null
	}
}

const mapDispatchToProps = {
	atualizarDadosAcesso: (idSessao) => atualizarDadosAcesso(idSessao),
}

const useStyles = makeStyles({
	containerCabecalho: {
		marginBottom: "5px",
		borderLeft: "2px solid #F4F5F7",
		borderRadius: "0.5px",
	},
	botaoSair: {
		cursor: "pointer",
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(Layout)